import { commentsData } from '@/mocks/homeData';

export default function CommentsSection() {
  return (
    <section id="comments" className="py-14 md:py-20 bg-background-50">
      <div className="mx-auto px-4 md:px-6 max-w-[860px]">
        <div className="text-center mb-10 md:mb-12">
          <span className="inline-block px-3 py-1 text-xs font-semibold text-secondary-700 bg-secondary-100 rounded-full mb-3">
            瓜友互动
          </span>
          <h2 className="text-2xl md:text-3xl font-bold text-foreground-900">读者热评</h2>
          <p className="mt-2 text-sm text-foreground-600">吃瓜群众的真实声音</p>
        </div>

        <div className="space-y-4">
          {commentsData.map((comment) => (
            <div
              key={comment.id}
              className="bg-background-100 rounded-lg border border-background-200/60 p-5 md:p-6"
            >
              <div className="flex items-start gap-3 md:gap-4">
                <div className="w-10 h-10 md:w-11 md:h-11 flex items-center justify-center rounded-full bg-primary-500 text-white font-bold text-sm md:text-base flex-shrink-0">
                  {comment.avatar}
                </div>
                <div className="flex-1 min-w-0">
                  <div className="flex items-center gap-2 mb-1 flex-wrap">
                    <span className="text-sm font-bold text-foreground-800">{comment.name}</span>
                    <span className="px-1.5 py-0.5 text-[10px] font-semibold bg-accent-100 text-accent-700 rounded">
                      {comment.tag}
                    </span>
                    <span className="text-[11px] text-foreground-500">{comment.time}</span>
                  </div>
                  <p className="text-sm text-foreground-700 leading-relaxed">{comment.content}</p>
                  <div className="flex items-center gap-1 mt-3 text-foreground-500">
                    <i className="ri-thumb-up-line text-sm"></i>
                    <span className="text-xs font-medium">{comment.likes.toLocaleString()}</span>
                  </div>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}